export default [
  '\\frac',
  '\\sqrt',
  '\\alpha',
  '\\begin',
  '\\beta',
  '\\cos',
  '\\cot',
  '\\delta',
  '\\epsilon',
  '\\gamma',
  '\\lambda',
  '\\lim',
  '\\lim',
  '\\lim',
  '\\mu',
  '\\nu',
  '\\omega',
  '\\phi',
  '\\pi',
  '\\psi',
  '\\rho',
  '\\sigma',
  '\\sin',
  '\\sum',
  '\\sum',
  '\\sum',
  '\\tan',
  '\\theta',
  '\\xi',
  '\\zeta',
  '\\cap',
  '\\cdot',
  '\\cup',
  '\\div',
  '\\eta',
  '\\mp',
  '\\mspace',
  '\\partial',
  '\\pm',
  '\\Sigma',
  '\\times',
  '\\triangle',
  '\\begin{array}',
  '\\acute',
  '\\aleph',
  '\\Delta',
  '\\Gamma',
  '\\int',
  '\\int',
  '\\int',
  '\\Lambda',
  '\\mathrm',
  '\\Omega',
  '\\Phi',
  '\\Pi',
  '\\Psi',
  '\\Theta',
  '\\begin{align}',
  '\\begin{Bmatrix}',
  '\\begin{bmatrix}',
  '\\begin{matrix}',
  '\\begin{pmatrix}',
  '\\begin{split}',
  '\\begin{Vmatrix}',
  '\\begin{vmatrix}',
  '\\binom',
  '\\left',
  '\\right',
  '\\begin{align*}',
  '\\begin{cases}',
  '\\begin{eqnarray}',
  '\\begin{eqnarray*}',
  '\\begin{equation}',
  '\\begin{equation*}',
  '\\abs',
  '\\absolutevalue',
  '\\acomm',
  '\\acos',
  '\\acosecant',
  '\\acosine',
  '\\acot',
  '\\acotangent',
  '\\acsc',
  '\\amalg',
  '\\And',
  '\\angle',
  '\\approx',
  '\\approxeq',
  '\\arccos',
  '\\arccosecant',
  '\\arccosine',
  '\\arccot',
  '\\arccotangent',
  '\\arccsc',
  '\\arcsec',
  '\\arcsecant',
  '\\arcsin',
  '\\arcsine',
  '\\arctan',
  '\\arctangent',
]
